exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-projects-project-key-tsx": () => import("./../../../src/pages/projects/[projectKey].tsx" /* webpackChunkName: "component---src-pages-projects-project-key-tsx" */)
}

